var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0006 22C6.47769 22 2 17.5236 2 12.0006C2.00626 6.48019 6.48019 2.00626 12.0006 2C17.5223 2 22 6.47769 22 12.0006C22 17.5236 17.5223 22 12.0006 22ZM12.0006 3.6674C7.39776 3.6674 3.66615 7.39776 3.66615 12.0006C3.67115 16.601 7.40026 20.3288 12.0006 20.3339C16.6022 20.3339 20.3339 16.6035 20.3339 12.0006C20.3339 7.39776 16.6022 3.6674 12.0006 3.6674ZM8.21429 11.7366L10.2318 13.7541L15.4876 8.49833C15.864 8.1219 16.4743 8.1219 16.8507 8.49833C17.2271 8.87475 17.2271 9.48505 16.8507 9.86147L10.914 15.7982C10.5397 16.1724 9.93431 16.1746 9.55739 15.8047C9.5471 15.7953 9.53696 15.7856 9.52698 15.7756L6.85115 13.0998C6.47473 12.7233 6.47473 12.113 6.85115 11.7366C7.22758 11.3602 7.83787 11.3602 8.21429 11.7366Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.032bc98ffd74505dcf79ce72d387f779.svg";
export { ForwardRef as ReactComponent };